import React from 'react';
import _ from 'lodash';

import { useRecentReturnAuthorizationListWidgetQuery } from 'generated/graphql';
import { DateTime } from 'luxon';



export interface IReturnAuthorization {
  id: string;
  returnNumber: string;
  returnDate: DateTime;
}

export interface IData {
  returnAuthorizations: IReturnAuthorization[];
}

export function useQuery() {
  const tuple = useRecentReturnAuthorizationListWidgetQuery({
    fetchPolicy: 'network-only'
  });

  return React.useMemo(
    () => {
      const data: IData = {
        returnAuthorizations: _.map(tuple.data?.returnAuthorizations.nodes ?? [], (node): IReturnAuthorization => ({
          id: node.id,
          returnDate: DateTime.fromISO(node.returnDate),
          returnNumber: node.returnNumber
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
